export const openInbox = () => {}; //eslint-disable-line
